export const types: Record<string, string> = {
  'hdrelay-2021': 'Video',
  'hdrelay-minimal': 'Minimal',
  'timeelapsed-2021': 'Frames/Pano',
};
